import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Profile from "../pages/profile/page";
import Category from "../pages/category/page";
import AdminPanel from "../pages/admin/page";
import AdminLoginPage from "../pages/admin-login/page";
import ProductListingPage from "../pages/product-listing/page";
import DeliveryPanel from "../pages/delivery/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/category",
    element: <Category />,
  },
  {
    path: "/admin",
    element: <AdminPanel />,
  },
  {
    path: "/admin-login",
    element: <AdminLoginPage />,
  },
  {
    path: "/product-listing",
    element: <ProductListingPage />,
  },
  {
    path: "/delivery",
    element: <DeliveryPanel />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;